import React from 'react';
import '../../../css/Form.css';
import '../../../css/Dashboard.css';
import Utils from '../../../helper/Utils';

const InterviewScheduleDetails = (props) => {
	const { interviewDetails } = props;
	return (
		<div className="parentBoxDiv border">
			<div className="boxheader withBorder ">
				<h3 id="headers"><b>Interview schedule details</b></h3>
			</div>
			<div className="boxbody">
				<div className="row">
					<div className="col-md-5 ">
						<label className="boxbodylabel" >
							Date and Time
						</label>
					</div>
					<div className='col-md-1'>
						:
					</div>
					<div className="col-md-4">
						<p className="boxbodyPara">{Utils.convertLocalDateToDD_MMM_YYYY_HH_MM(interviewDetails.date)}</p>
					</div>
				</div>
				{!Utils.isNullorWhiteSpace(interviewDetails.reportingTime) && (
					<div className="row">
						<div className="col-md-5">
							<label className="boxbodylabel">
								Reporting Time
							</label>
						</div>
						<div className="col-md-1" >
							:
						</div>
						<div className="col-md-4">
							{/* <p className="boxbodyPara">{Utils.convertLocalDateToDD_MMM_YYYY_HH_MM(interviewDetails.date)}</p> */}
							<p className="boxbodyPara">{Utils.convertLocalArrayTimeToString(interviewDetails.reportingTime)}</p>
						</div>
					</div>
				)}
				<div className="row">
					<div className="col-md-5 col-5">
						<label className="boxbodylabel">
							Venue and Contact Details
						</label>
					</div>
					<div className='col-md-1 '>
						:
					</div>
					<div className="col-md-6 col-5">
						<p className="boxbodyPara textarea-display" style={{ whiteSpace: "pre-line" }}>{interviewDetails.venue}</p>
					</div>
				</div>
				<div className="row">
					<div className="col-md-5 col-5">
						<label className="boxbodylabel">
							Google Map
						</label>
					</div>
					<div className="col-md-1">
						:
					</div>
					<div className="col-md-6 col-5">
						<a
							href={interviewDetails.venueLink}
							rel="noreferrer"
							target="_blank"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								gap: '7px',
								color: '#1a73e8',
								fontWeight: '600',
								fontSize: '0.85rem',
								textDecoration: 'none',
								background: '#ffffff',
								border: '1.5px solid #dadce0',
								borderRadius: '8px',
								padding: '5px 14px 5px 10px',
								marginTop: '4px',
								boxShadow: '0 1px 4px rgba(60,64,67,0.18)',
								letterSpacing: '0.01em'
							}}
						>
							<i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: '1.05rem', color: '#EA4335' }}></i>
							Open in Google Maps
						</a>
					</div>
				</div>
				<div className="row">
					<div className="col-md-5">
						<label className="boxbodylabel">
							Point of contact
						</label>
					</div>
					<div className='col-md-1'>
						:
					</div>
					<div className="col-md-4 col-5">
						<p className="boxbodyPara">{interviewDetails.pointOfContact}</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InterviewScheduleDetails;
